import CONSTANTS from '../constants';
import DEFAULT_FILTERS from '../defaultFilters';
import _ from 'lodash';
import moment from 'moment';

export default {
	applyFilters,
	getDefaultFilters,
	getNewFilters,
	filtersToParams
};

let COMPARISON = {
	'<=': function (a, b) { return a <= b; },
	'<':  function (a, b) { return a < b; },
    // eslint-disable-next-line
	'==': function (a, b) { return a == b; },
	'===': function (a, b) { return a === b; },
	'>':  function (a, b) { return a > b; },
	'>=': function (a, b) { return a >= b; },
	'contains': function (a, b) { return _.includes(a,b)},
	default: function () { return true; }
};

function filtersToParams(filters) {
	let params = {};
	_.each(filters, (filter) => {
		if(filter.type === CONSTANTS.FILTERS.TYPES.DATE)
			params[filter.key] = moment(filter.value, CONSTANTS.DATE.FORMAT.DISPLAY).format(CONSTANTS.DATE.FORMAT.DEFAULT);
		else
			params[filter.key] = filter.value
	});
	return params;
}

function applyFilters(filters, records) {
	let filtersToBeApplied =  _.map(filters, (filter) => {
		if(filter.type === CONSTANTS.FILTERS.TYPES.DATE){
			return _.defaults({value: moment(filter.value, CONSTANTS.DATE.FORMAT.DISPLAY).unix()}, filter);
		}
        return filter;
	});

	return _.filter(records, (record) => { return filter(record, filtersToBeApplied); });
}

function filter(record, filters) {
	let conditionals = _.map(filters, (f) => {
		let transformedValue = transformValue(record[f.key], f.type);
		return applyConditional(transformedValue, f.value, f.comparator)
	});
	return !_.include(conditionals, false);
}

function applyConditional(recordValue, filterValue, comparator) {
	if (filterValue === '') {
		return true; // So that all records show if filter value is empty
	}
	return (COMPARISON[comparator] || COMPARISON.default)(recordValue, filterValue);
}

function transformValue(value, filterType) {
	if(value && filterType) {
		if(filterType === CONSTANTS.FILTERS.TYPES.DATE) {
			return moment(value, CONSTANTS.DATE.FORMAT.DEFAULT).unix();
		}
		return value;
	}
	return null;
}

function getDefaultFilters(componentType) {
	return _.map(DEFAULT_FILTERS[componentType], (defaultFilter) => {
		return _.defaults({value: defaultFilter.defaultValue}, defaultFilter);
	});
}

function getNewFilters(newValues, oldFilters) {
	return _.map(_.keys(newValues), function(key) {
		let filter = _.find(oldFilters, (f) => f.key === key );
		let value;
		if(filter.type === CONSTANTS.FILTERS.TYPES.DATE) {
			value = moment(newValues[key]).format(CONSTANTS.DATE.FORMAT.DISPLAY);
		} else {
			value = newValues[key];
		}
		return _.defaults({value: value}, filter);
	});
}


// WEBPACK FOOTER //
// ./src/services/filterService.js